<template>
  <v-overlay class="align-center justify-center" persistent>
    <v-progress-circular
      :size="80"
      color="red-darken-2"
      indeterminate
    ></v-progress-circular>
  </v-overlay>
</template>
